import type { ReactNode } from "react";
import { tokens } from "@core/theme/tokens";

// PA-025-D (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025.json): extraído desde
// rewards/RewardsScreen.tsx, donde vivía como función local (SPEC-210).
// SPEC-211 (Beneficios Star Circle) necesita el mismo grupo de campo sin
// `<label>` envolvente para sus propios lugares de consumo — duplicar estas
// ~30 líneas en dos pantallas haría fallar `dup:check` (`web/.jscpd.json`,
// threshold 3) sobre una deuda de duplicación que el humano ya dejó
// declarada (SPEC-210 known_defects). Sin `<label>` envolvente (mismo motivo
// documentado originalmente en `GPFieldGroup` de
// grand-prize/GrandPrizeConfigScreen.tsx): un grupo de checkboxes dentro de
// un `<label>` rompe el nombre accesible de cada control.
//
// Extracción sin cambio de comportamiento ni de valores visuales: ninguna
// pantalla que la use cambia un pixel por esto.
export function RFieldGroup({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: string;
  children: ReactNode;
}) {
  return (
    <div style={{ marginBottom: 16 }}>
      <div className="label" style={{ marginBottom: 7 }}>
        {label}
      </div>
      {children}
      {hint ? (
        <div
          style={{
            font: `400 11px/1.45 ${tokens.font.ui}`,
            color: tokens.text.disabled,
            marginTop: 6,
          }}
        >
          {hint}
        </div>
      ) : null}
    </div>
  );
}
